import { render, staticRenderFns } from "./Comparecientes.vue?vue&type=template&id=28b96194&scoped=true"
import script from "./Comparecientes.vue?vue&type=script&lang=js"
export * from "./Comparecientes.vue?vue&type=script&lang=js"
import style0 from "./Comparecientes.vue?vue&type=style&index=0&id=28b96194&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b96194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b96194')) {
      api.createRecord('28b96194', component.options)
    } else {
      api.reload('28b96194', component.options)
    }
    module.hot.accept("./Comparecientes.vue?vue&type=template&id=28b96194&scoped=true", function () {
      api.rerender('28b96194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/comparecientes/Comparecientes.vue"
export default component.exports